// extracted by mini-css-extract-plugin
export var boldText = "_76-4";
export var checkboxContainer = "_76-6";
export var closeIcon = "_76-i";
export var container = "_76-0";
export var drawer = "_76-8";
export var drawerContent = "_76-9";
export var extraSmallText = "_76-5";
export var fulfillmentGroupTable = "_76-e";
export var largeText = "_76-3";
export var loadingSpinnerContainer = "_76-j";
export var mediumText = "_76-2";
export var narrow = "_76-f";
export var notificationLink = "_76-l";
export var packageCheckIconContainer = "_76-7";
export var slideoutHeaderActions = "_76-g";
export var slideoutHeaderActionsShifted = "_76-h";
export var slideoutHeaderContainer = "_76-a";
export var slideoutModal = "_76-c";
export var stickyHeaderWrapper = "_76-b";
export var table = "_76-k";
export var tableContainer = "_76-d";
export var tertiaryText = "_76-1";